(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("orderLineBomService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1512,
                    parameters: parms || {}
                });
            },
            listBoms: function (parms) {
                return $ihttp.post({
                    method: 1513,
                    parameters: parms || {}
                });
            },
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1515,
                    parameters: parms || {}
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 2732,
                    parameters: edit
                });
            },
            switchObj: function (edit) {
                return $ihttp.post({
                    method: 2733,
                    parameters: edit
                });
            },
            addObj: function (edit) {
                return $ihttp.post({
                    method: 2734,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
